module.exports = __webpack_public_path__ + "img/system21-mini.c4b53da9.png";